// token to access a stream with the information you need
import {InjectionToken, Provider} from '@angular/core';

export const CART_QUANTITY_DEBOUNCE_TIME = new InjectionToken<number>(
  'The time before sending cart quantity update request'
);

export const DURATION_PROVIDERS: Provider[] = [
  {
    provide: CART_QUANTITY_DEBOUNCE_TIME,
    useValue: 400
  }
];

